import DimSymbolsCommand, { DimType } from "slotworks/commands/symbols/dim-symbols-command";
import { HighlightSymbolsCommand } from "slotworks/commands/symbols/highlight-symbols-command";
import Components from "slotworks/components/components";
import GameState from "slotworks/model/game-state";
import { Services } from "slotworks/services/services";
import GatewayResult from "model/gameplay/records/results/gateway-result";
import ScatterResult from "slotworks/model/gameplay/records/results/scatter-result";

class GatewayCelebrationComponent {
    public playFreespinsCelebration() {
        const record = GameState.getCurrentGame().getCurrentRecord();
        const result = record.getResultsOfType(GatewayResult)[0] || record.getResultsOfType(ScatterResult)[0];

        this.displayFooterMessage(result);

        const allSymbols = Components.matrix.getBaseGridSymbols();
        const gatewayResult = result as GatewayResult;
        const winningSymbols = this.getSymbolsById(gatewayResult.symbolType);
        const hiddenSymbols = Components.matrix.getHiddenSymbols();

        DimSymbolsCommand(allSymbols.concat(hiddenSymbols), DimType.Win, gatewayResult).execute();

        Services.sound.customEvent("BN_highlight");

        return HighlightSymbolsCommand(winningSymbols, gatewayResult);
    }

    protected displayFooterMessage(result: GatewayResult | ScatterResult) {
        const credits = Services.currency.format(this.getWinAmount(result));
        const matches = result.matches;
        const message = result instanceof GatewayResult ? "bonus_with_credits" : "retrigger_with_credits";

        Components.footer.showCustomResult(result, message, { matches, credits }).execute();
    }

    protected getWinAmount(result: GatewayResult | ScatterResult) {
        let amount = result.cashWon;

        if (result instanceof GatewayResult) {
            amount = result.winAmount;
        }

        return amount;
    }

    protected getSymbolsById(symbolId: string) {
        return Components.matrix.getGridSymbols().filter((symbol) => {
            return symbol.symbolId === symbolId;
        });
    }
}

export default new GatewayCelebrationComponent();
